import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const changeLanguage = (lng) => {
    if (i18n.language !== lng) {
      i18n.changeLanguage(lng);
      navigate(`/${lng}${location.pathname.replace(/^\/[a-z]{2}/, "")}`, { replace: true });
    }
  };

  return (
    <select value={i18n.language} onChange={(e) => changeLanguage(e.target.value)}>

      <option value="en">English</option>
      <option value="id">Indonesia</option>
      <option value="fr">French</option>
      <option value="th">Thai</option>
      <option value="ru">Russian</option>


    </select>
  );
};

export default LanguageSelector;
